import React, {useEffect} from "react";
import {
    Box,
    Button,
    Checkbox,
    FormControl,
    FormControlLabel,
    FormGroup,
    Grid,
    InputLabel,
    MenuItem,
    Select,
    TextField
} from "@mui/material";
import chargeConstants from "../../ChargeManagement/constants";
import {Autocomplete} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutlined";

export default function SelectedItemBlock(props) {

    useEffect(() => {

        props.setIsChildChanged(!props.childChanged);
        updateBlockingChildren();

    }, [props.item.type, props.item.key, props.item.category, props.item.customFields, props.item.amount])


    function updateBlockingChildren() {
        let newBlockingChildrenList = [...props.someChildIsBlocking];
        newBlockingChildrenList[props.index] = someFieldBlocks();
        props.setSomeChildIsBlocking(newBlockingChildrenList);
    }

    const someFieldBlocks = () => {
        let selectedType = props.chargeTypes.filter(i => i.key === props.item.key);
        if (selectedType.length === 0) {
            return true;
        }
        if (selectedType.length > 0 && selectedType[0].key && !props.item.key || !props.item.type) {
            return true;
        }

        if (selectedType[0]?.consumable && !props.item.amount) {
            return true;
        }

        if (selectedType[0]?.customFields.length > 1) {
            for (let i in selectedType[0].customFields) {
                if (!props.item.customFields
                    || props.item.customFields[selectedType[0].customFields[i]['key']] === undefined
                    || props.item.customFields[selectedType[0].customFields[i]['key']] === "") {
                    return true;
                }
            }
        }

        return false;
    }

    function getUniqueItems(items) {
        return Array.from(new Set(items))
    }

    const isLast = props.index === props.selectedItemList.length - 1;
    const canRemove = props.index !== 0 || props.selectedItemList.length > 1;

    return (
        <Box sx={{mb: 3}}>
            <Grid container spacing={2} sx={{alignItems: "center"}}>
                <Grid size={{ xs: 3 }} sx={{
                    mt: 0
                }}>
                    <FormGroup id={"cmform__charge-type"}>
                        <FormControl fullWidth key={`type-${props.item.type}`}>
                            <InputLabel shrink={!!props.item.type}>Type</InputLabel>
                            <Select
                                value={props.item.type}
                                label="Type"
                                onChange={(event) => props.handleChange(event.target.value, props.item, "type")}
                            >
                                {props.isSuccess && getUniqueItems(props.chargeTypes.map(i => i.type)).map(item => (
                                    <MenuItem value={item}>{chargeConstants.CmChargeTypeOptions[item]}</MenuItem>
                                ))}

                            </Select>
                        </FormControl>
                    </FormGroup>
                </Grid>
                <Grid size={{ xs: 3 }} sx={{
                    mt: 0
                }}>
                    {props.item.type &&
                        <FormGroup id={"cmform__charge-category"}>
                            <FormControl fullWidth>
                                <InputLabel>Category</InputLabel>
                                <Select
                                    value={props.item.category}
                                    label="Category"
                                    onChange={(event) => props.handleChange(event.target.value, props.item, "category")}
                                >
                                    {getUniqueItems(props.chargeTypes.filter(i => i.type === props.item.type).map(i => i.category))
                                        .map(item => (<MenuItem value={item}>{item}</MenuItem>))}
                                </Select>
                            </FormControl>
                        </FormGroup>}
                </Grid>
                <Grid size={{ xs: 3 }} sx={{
                    mt: 0
                }}>

                    {props.item.category &&
                        <Autocomplete
                            disablePortal
                            id="combo-box-demo"
                            options={props.chargeTypes.filter(i => i.category === props.item.category)}
                            fullWidth={true}
                            renderInput={(params) => <TextField {...params} label="Item"/>}
                            getOptionLabel={(option) => option.title}
                            isOptionEqualToValue={(option, value) => option.id === value.id}
                            onChange={(event, selectedOption) => {
                                if (selectedOption) {
                                    props.item.selectedId = selectedOption.id;
                                    props.handleChange(selectedOption.key, props.item, "key");
                                } else {
                                    props.item.selectedId = null;
                                    props.handleChange('', props.item, "key");
                                }
                            }}
                            value={
                                (props.item.selectedId && props.chargeTypes.find(i => i.id === props.item.selectedId)) ||
                                (props.item.key && props.chargeTypes.find(i => i.key === props.item.key && i.category === props.item.category)) ||
                                null
                            }
                        />
                    }
                </Grid>
                {(props.item.key === "" || props.item.key === "0") && (
                    <>
                        <Grid size={{ xs: 1.5 }} sx={{
                            mt: 0
                        }}>
                            <FormGroup>
                                <FormControl fullWidth>
                                    <TextField
                                        label="Manual ID"
                                        value={props.item.customKey || ""}
                                        onChange={(e) => props.handleChange(e.target.value, props.item, "customKey")}
                                        variant="outlined"
                                        placeholder="Manual ID"
                                    />
                                </FormControl>
                            </FormGroup>
                        </Grid>
                        <Grid size={{ xs: 1.5 }} sx={{
                            mt: 0
                        }}>
                            <TextField
                                label="Amount"
                                value={props.item.amount || ""}
                                onChange={(e) => props.handleChange(e.target.value, props.item, "amount")}
                                variant="outlined"
                                fullWidth
                                type="number"
                                placeholder="Amount"
                            />
                        </Grid>
                    </>
                )}
                {props.item.key
                    && props.item.type === chargeConstants.CmChargeTypeOptions.items.toLowerCase() &&<Grid size={{ xs: 3 }} sx={{
                    mt: 0
                }}>

                        <FormGroup>
                            <FormControl fullWidth>
                                <TextField
                                    label={props.chargeTypes.filter(i => i.key === props.item.key)[0]?.consumable ? "Amount" : "Duration"}
                                    value={props.item.amount}
                                    type={'number'}
                                    onChange={(event) => {
                                        props.handleChange(event.target.value, props.item, "amount")
                                    }}>
                                </TextField>
                            </FormControl>
                        </FormGroup>
                </Grid>}
                {props.item.key && (props.chargeTypes.filter(i => i.key === props.item.key)[0]?.customFields.map((field, customFieldIndex) => {
                        return (
                            <Grid size={{ xs: 6 / props.chargeTypes.filter(i => i.key === props.item.key)[0]?.customFields.length }}>
                                <FormGroup>
                                    {field.type !== chargeConstants.CmChargeAdditionalFieldsTypes[1] ?
                                        <TextField
                                            type={field.type === chargeConstants.CmChargeAdditionalFieldsTypes[2] ? 'number' : ""}
                                            label={field.title}
                                            value={props.item['customFields']?.[customFieldIndex]?.key}
                                            onChange={(event) => {
                                                props.handleChangeCustomFields(field.key, event.target.value, props.item, customFieldIndex);
                                            }}
                                        >
                                        </TextField> :
                                        <FormControlLabel sx={{pl: 1}}
                                                          label={field.title}
                                                          control={
                                                              <Checkbox
                                                                  checked={String(props.item['customFields'] ? props.item['customFields'][field.key] : "") === 'true'}
                                                                  onChange={(event) => props.handleChangeCustomFields(field.key, event.target.checked, props.item, customFieldIndex)}
                                                              >
                                                              </Checkbox>
                                                          }
                                        />
                                    }
                                </FormGroup>
                            </Grid>

                        )
                    }
                ))}
            </Grid>
            {/* Action Buttons — same layout as toh/mc/ds Guid2Block */}
            <Grid container spacing={1} sx={{mt: 1}}>
                {canRemove && (
                    <Grid>
                        <Button
                            variant="outlined"
                            color="error"
                            startIcon={<DeleteIcon/>}
                            onClick={() => props.handleRemoveItem(props.index)}
                        >
                            Remove
                        </Button>
                    </Grid>
                )}
                {isLast && props.handleAddItem && (
                    <Grid>
                        <Button
                            variant="outlined"
                            color="info"
                            startIcon={<AddCircleOutlineIcon/>}
                            onClick={props.handleAddItem}
                        >
                            Add
                        </Button>
                    </Grid>
                )}
            </Grid>
        </Box>
    );
}
